import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { useTranslation } from "react-i18next";

/**
 * A component that renders a timepicker using MUI. It internally uses dayjs to represent dates.
 *
 * @param {Object} props
 * @param {string} props.value - The value of the selected date
 * @param {string} props.name - The HTML name of the input
 * @param {(e: string)=>{}} props.onChange - A function that runs when the selected option changes
 * @param {boolean} props.disabled - Whether the input is disabled or not
 * @returns {JSX.Element}
 */

const TimePicker = ({ value, onChange, name, disabled }) => {
  const { t, i18n } = useTranslation("global");
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={i18n.language}
    >
      <MobileTimePicker
        name={name}
        className={"w-full"}
        value={value}
        onChange={onChange}
        disabled={disabled}
        localeText={{
          toolbarTitle: t("select_time"),
          cancelButtonLabel: t("cancel"),
          okButtonLabel: t("ok"),
        }}
        format={"hh:mm A"}
        sx={{
          "& .MuiOutlinedInput-root": {
            height: "40px",
            color: "#5D5D5D",
            "&:hover fieldset": { borderColor: "var(--primary)" },
            "&.Mui-focused fieldset": { borderColor: "var(--primary)" },
          },
          "& .MuiInputLabel-root": {
            color: "var(--primary)",
            "&.Mui-focused": { color: "var(--primary)" },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default TimePicker;
